import Vue from 'vue';
import VueCompositionAPI, { provide } from '@vue/composition-api';
Vue.use(VueCompositionAPI);
import App from './App.vue';
import router from '@/router/index';
import { BootstrapVue } from 'bootstrap-vue';
import Constants, { DynamicConstants } from './constants';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
import PortalVue from 'portal-vue';
Vue.use(PortalVue);
Vue.component('font-awesome-icon', FontAwesomeIcon);
import 'vue-toastification/dist/index.css';
import oidc from '@/composables/useOidc';
import '@/styles/icons.ts';
import '@/styles/style.scss';
import axios from 'axios';
import i18n from './i18n';
import './filters/formatDateFilter';
import VueApollo from 'vue-apollo';
import apolloClient from './graphql/client';
import { DefaultApolloClient } from '@vue/apollo-composable';
import { PluginOptions } from 'vue-toastification/src/types';
Vue.use(VueApollo);
axios.get(Constants.config_url).then(({ data }) => startApp(new DynamicConstants(data)));
import Toast from 'vue-toastification';
import { provideToast } from 'vue-toastification/composition';
const toastOptions: PluginOptions = {
  timeout: 5000,
  closeButton: false,
  closeOnClick: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: false,
  icon: false,
  maxToasts: 1,
  transition: {
    enter: 'Vue-Toastification__bounce-enter-active',
    leave: 'fade',
    move: 'fade'
  }
};
Vue.use(Toast, toastOptions);

async function startApp(constants: DynamicConstants) {
  oidc()
    .initialize(constants.authority, constants.clientId, router)
    .then(() => {
      const vue = new Vue({
        router,
        i18n,
        setup() {
          provideToast(toastOptions);
          provide(DefaultApolloClient, apolloClient(constants));
          provide('constants', constants);
        },

        render: h => h(App)
      });

      vue.$mount('#app');
    });
}
